import { fetchPackages } from "modules/membership_plan/commercial_membership_plan/packages/store/action";
import { connect } from "react-redux";
import { AddPackageInput, AddPackageInputError } from "../../store/actionType";
import { useEffect, useState } from "react";
import { PackageProps } from "modules/membership_plan/commercial_membership_plan/packages/store/actionType";
import { CancelButton, Error, SubmitButton } from "components";
interface FormProps {
  loading: boolean;
  header: string;
  formData: AddPackageInput;
  error: AddPackageInputError;
  handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmit?: React.MouseEventHandler<HTMLButtonElement>;
  onClose: () => void;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps & FormProps;
const AddPackageForm: React.FC<Props> = ({
  onFetchPackages,
  fetchPackages,
  loading,
  header,
  formData,
  handleChange,
  handleSubmit,
  error,
  onClose,
}) => {
  const [selectedPackages, setSelectedPackages] = useState<string[]>(
    formData.package_ids || []
  );

  useEffect(() => {
    onFetchPackages();
  }, []);

  useEffect(() => {
    setSelectedPackages(formData.package_ids || []);
  }, [formData.package_ids]);

  const onPackageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const pkgId = e.target.value;
  let updatedPackages: string[];
  setSelectedPackages((prev) => {
    if (e.target.checked) {
      updatedPackages = [...prev, pkgId];
    } else {
      updatedPackages = prev.filter((id) => id !== pkgId);
    }
    if (handleChange) {
      handleChange({
        ...e,
        target: {
          ...e.target,
          name: "package_ids",
          value: updatedPackages,
        },
      } as any);
    }
    return updatedPackages;
  });
};
  const onSubmit = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const dataToSubmit = {
      ...formData,
      package_ids: selectedPackages,
    };

    if (handleSubmit) {
      handleSubmit(e);
    }
    onClose();
  };
  return (
    <div>
      <form>
        <h2 className="text-xl font-bold my-3">{header}</h2>
        {fetchPackages?.packages?.map((pkg: PackageProps) => (
          <div key={pkg.id}>
            <input
              type="checkbox"
              id={`package-${pkg.id}`}
              name="package"
              value={pkg.id}
              className="mr-2"
              checked={selectedPackages.includes(pkg.id)}
              onChange={onPackageChange}
            />
            <label htmlFor={`package-${pkg.id}`}>{pkg.name}</label>
          </div>
        ))}
        {error.package_ids && selectedPackages.length === 0 && (
          <Error>{error.package_ids}</Error>
        )}
        <div className="mt-4 w-full flex justify-between">
          <CancelButton onClick={onClose} />
          <SubmitButton loading={loading} onClick={onSubmit} />
        </div>
      </form>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  fetchPackages: state.packages?.fetchPackagesState,
});

const mapDispatchToProps = (dispatch: any) => ({
  onFetchPackages: () => dispatch(fetchPackages()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddPackageForm);
